import { jsx, jsxs } from "@emotion/react/jsx-runtime";
import { useTheme, css } from "@emotion/react";
import { Field } from "formik";
import FormFieldDescription from "./FormFieldDescription.mjs";
import FormFieldError from "./FormFieldError.mjs";
import FormFieldLabel from "./FormFieldLabel.mjs";
import FormFieldWrapper from "./FormFieldWrapper.mjs";
import { useThemeProps, handleComponentsProp, MaybeFragment, ToggleButtonGroup } from "@wsui/base";
function FormToggleButtonGroupField(props) {
  props = useThemeProps({
    props,
    name: "FormToggleButtonGroupField"
  });
  props = useThemeProps({
    props,
    name: "FormField"
  });
  let {
    inputProps = {},
    buttonProps = {},
    placeholder,
    components,
    rowGap = [1, 2],
    options,
    ...restProps
  } = props;
  let {
    Field: Field$1,
    FormFieldDescription: FormFieldDescription$1,
    FormFieldError: FormFieldError$1,
    FormFieldLabel: FormFieldLabel$1,
    FormFieldWrapper: FormFieldWrapper$1
  } = handleComponentsProp(components, {
    Field,
    FormFieldDescription,
    FormFieldError,
    FormFieldLabel,
    FormFieldWrapper
  });
  const theme = useTheme();
  let {
    ...restInputProps
  } = inputProps;
  return /* @__PURE__ */jsx(FormFieldWrapper$1, {
    css: /* @__PURE__ */css("display:grid;grid-template-columns:1fr;grid-row-gap:", theme.getLength(rowGap), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:FormToggleButtonGroupField;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
    ...restProps,
    children: _ref => {
      let {
        name,
        controlProps,
        wrapperProps,
        type,
        id,
        multiple,
        inputProps: inputProps2
      } = _ref;
      return /* @__PURE__ */jsxs(MaybeFragment, {
        ...wrapperProps,
        children: [/* @__PURE__ */jsx(FormFieldLabel$1, {}), /* @__PURE__ */jsx(FormFieldDescription$1, {}), /* @__PURE__ */jsx("div", {
          children: /* @__PURE__ */jsx(Field$1, {
            as: ToggleButtonGroup,
            type,
            name,
            id,
            placeholder,
            options,
            multiple,
            ...controlProps,
            ...inputProps2,
            ...restInputProps,
            buttonProps
          })
        }), /* @__PURE__ */jsx(FormFieldError$1, {})]
      });
    }
  });
}
export { FormToggleButtonGroupField as default };